import { ReactNode, useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { useAuthStore } from '@/stores/authStore';
import { usePortalConfigStore } from '@/stores/portalConfigStore';

interface AppLoaderProps {
  children: ReactNode;
}

export function AppLoader({ children }: AppLoaderProps) {
  const isHydrated = useAuthStore((state) => state.isHydrated);
  const { isLoaded: isConfigLoaded, fetchConfig } = usePortalConfigStore();
  const [showLoader, setShowLoader] = useState(true);

  // Fetch portal config on mount
  useEffect(() => {
    fetchConfig();
  }, [fetchConfig]);

  useEffect(() => {
    // Show the app once both auth hydration and config are ready
    if (isHydrated && isConfigLoaded) {
      const timeout = setTimeout(() => {
        setShowLoader(false);
      }, 50);
      return () => clearTimeout(timeout);
    }
  }, [isHydrated, isConfigLoaded]);

  // Fallback: if loading takes too long, show the app anyway
  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowLoader(false);
    }, 2000);
    return () => clearTimeout(timeout);
  }, []);

  if (showLoader && !(isHydrated && isConfigLoaded)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-950">
        <div className="text-center">
          <Loader2 className="h-8 w-8 animate-spin text-primary-600 mx-auto mb-4" />
          <p className="text-gray-600 dark:text-gray-400">Loading...</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
